export const IMAGE_TYPES = ['jpeg', 'jpg', 'png', 'JPEG', 'JPG', 'PNG'];

export const RELATION_LIST = ['친구', '지인', '동료', '가족'];
export const FONT_LIST = ['Noto Sans', 'Pretendard', 'sans-serif'];
